import React from 'react';

interface TimerBoxProps {
  remainingTime: number | null; // Time in milliseconds
  formatTime: (time: number | null) => string; // Formatting function for time
}

const TimerBox: React.FC<TimerBoxProps> = ({ remainingTime, formatTime }) => {
  return (
    <div
      style={{
        flexGrow: 1,
        height: '60px',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '10px',
      }}
    >
      <div
        className="timer-box"
        style={{
          width: '100px',
          height: '50px',
          padding: '10px',
          borderRadius: '12px',
          background: '#fff',
          color: '#333',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'transform 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        {remainingTime !== null && remainingTime > 0 ? (
          <div>{formatTime(remainingTime)}</div>
        ) : (
          <div>{remainingTime === null ? 'Ανανέωση...' : 'Session Expired'}</div>
        )}
      </div>
    </div>
  );
};


export default TimerBox;
